<script setup lang="ts">
  import { CartLayout, CartWithSummaryLayout } from '@storefront/components';
  import { useVerifiedCart } from '@storefront/storefront';

  defineOptions({
    layout: [CartLayout, CartWithSummaryLayout],
    inheritAttrs: false,
  });

  const cart = useVerifiedCart();
</script>
<template>
  <FormController :action="$route('web.cart.note.update')" method="PATCH" :data="cart" v-slot="{ data, processing, submit }">
    <div class="customer-note-form">
      <div class="shipping-data-wrapper__switch-note">
        <SfFormSwitch name="hasCustomerNote">
          {{ $t('SHOP.CART.LABEL.ADD_ADDITIONAL_INFORMATION') }}
        </SfFormSwitch>
      </div>
      <div v-if="data.hasCustomerNote" class="shipping-data-wrapper__textarea-note">
        <SfFormTextarea :label="$t('SHOP.CART.LABEL.ADDITIONAL_INFORMATION')" name="customerNote" />
      </div>
      <UiButtonGroup>
        <SfButton primary small :loading="processing" @click="submit">
          {{ $t('SHOP.CART.ACTION.CONTINUE') }}
        </SfButton>
      </UiButtonGroup>
    </div>
  </FormController>

  <RouterView />
</template>
<style scoped lang="scss">
  .customer-note-form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 672px;
  }
</style>
